import { render, staticRenderFns } from "./articleItem.vue?vue&type=template&id=4a317f5c&scoped=true"
import script from "./articleItem.vue?vue&type=script&lang=ts"
export * from "./articleItem.vue?vue&type=script&lang=ts"
import style0 from "./articleItem.vue?vue&type=style&index=0&id=4a317f5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a317f5c",
  null
  
)

export default component.exports